<template>
  <div class="ba-card">
    <a
      :href="makeUrl(data)"
      :target="data.link_externo === '0' ? '_self' : '_blank'"
    >
      <div class="img-holder">
        <img v-if="data.arquivo" :src="data.arquivo.link" :alt="data.titulo" />
        <img
          v-else
          src="@/assets/imgs/no-image-portal.jpg"
          :alt="data.titulo"
          class="imagem-destaque"
        />
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'BarraAcessoCard',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    makeUrl(data) {
      const { noticia } = data;
      const baseUrl = process.env.BASE_URL;

      if (!noticia) {
        return data.url;
      }

      if (noticia.vivo_se_liga) {
        return baseUrl + `#/se-liga/${noticia.slug}`;
      }

      return baseUrl + `#/categoria/${noticia.categoria.slug}/post/${noticia.slug}`;
    },
  },
};
</script>

<style lang="scss">
.ba-card {
  padding: 10px;
  & .img-holder {
    user-select: none;
    position: relative;
    height: 106px;
    & img {
      border-radius: 5px;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>
